const name = 'EstilizacaoGlobal'
export default {
  name,

  components: { },

  props: { },

  mounted () { },

  updated () { },

  data () {
    return { }
  },

  methods: { },

  computed: { },

};